<app-button-feedback
  [_setId]="'btnInvalidateBatch_' + batch.id"
  *ngIf="batch.attributes.is_valid === 1"
  (click)="invalidateAccessCodeBatch()"
  [_defaultButtonText]="'access-code.invalidate_batch'"
  [_responseText]="invalidateAccessCodeBatchResponse | async"
  [_setIcon]="faBan"
></app-button-feedback>
